import produce from "immer";
import { LoadState } from "../../../constants/enums";
import {
	defaultExternalLeadMasterStatus,
	defaultExternalLeadStatus,
	defaultExternalLeadStatusState,
} from "./external-lead-status.state";
import {
	FETCH_EXTERNAL_STATUS_LIST_PROGRESS,
	FETCH_EXTERNAL_STATUS_LIST_SUCCESS,
	FETCH_EXTERNAL_STATUS_LIST_FAILED,
	FETCH_EXTERNAL_STATUS_PROGRESS,
	FETCH_EXTERNAL_STATUS_SUCCESS,
	FETCH_EXTERNAL_STATUS_FAILED,
	CLEAR_EXTERNAL_STATUS_STATE,
	FETCH_MASTER_EXTERNAL_STATUS_LIST_PROGRESS,
	FETCH_MASTER_EXTERNAL_STATUS_LIST_SUCCESS,
	FETCH_MASTER_EXTERNAL_STATUS_LIST_FAILED,
	FETCH_MASTER_EXTERNAL_STATUS_PROGRESS,
	FETCH_MASTER_EXTERNAL_STATUS_SUCCESS,
	FETCH_MASTER_EXTERNAL_STATUS_FAILED,
	CLEAR_MASTER_EXTERNAL_STATUS_STATE,
	FETCH_OUTLET_EXTERNAL_STATUS_LIFECYCLE_PROGRESS,
	FETCH_OUTLET_EXTERNAL_STATUS_LIFECYCLE_SUCCESS,
	FETCH_OUTLET_EXTERNAL_STATUS_LIFECYCLE_FAILED,
} from "./external-lead-status.action";
import { IExternalLeadStatusState } from "./external-lead-status.types";

export const externalLeadsLifeCycleReducer = (
	state: IExternalLeadStatusState = defaultExternalLeadStatusState,
	action: any
) => {
	switch (action.type) {
		// List Actions
		case FETCH_EXTERNAL_STATUS_LIST_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.statusList.loading = LoadState.NotLoaded;
				draftState.statusList.list = [];
				draftState.statusList.totalRecords = 0;
				draftState.statusList.error = null;
			});
		}

		case FETCH_EXTERNAL_STATUS_LIST_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.statusList.loading = LoadState.Loaded;
				draftState.statusList.list = data;
				draftState.statusList.error = null;
			});
		}

		case FETCH_EXTERNAL_STATUS_LIST_FAILED: {
			return produce(state, (draftState) => {
				draftState.statusList.loading = LoadState.Failed;
				draftState.statusList.error = "Failed to fetch external status list";
			});
		}

		// Single Status Actions
		case FETCH_EXTERNAL_STATUS_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.status.loading = LoadState.InProgress;
				draftState.status.data = defaultExternalLeadStatus;
			});
		}

		case FETCH_EXTERNAL_STATUS_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.status.loading = LoadState.Loaded;
				draftState.status.data = data;
				draftState.status.error = null;
			});
		}

		case FETCH_EXTERNAL_STATUS_FAILED: {
			return produce(state, (draftState) => {
				draftState.status.loading = LoadState.Failed;
			});
		}

		// Master External Status List Actions
		case FETCH_MASTER_EXTERNAL_STATUS_LIST_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.masterStatusList.loading = LoadState.NotLoaded;
				draftState.masterStatusList.list = [];
				draftState.masterStatusList.totalRecords = 0;
				draftState.masterStatusList.error = null;
			});
		}

		case FETCH_MASTER_EXTERNAL_STATUS_LIST_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.masterStatusList.loading = LoadState.Loaded;
				draftState.masterStatusList.list = data;
				draftState.masterStatusList.error = null;
			});
		}

		case FETCH_MASTER_EXTERNAL_STATUS_LIST_FAILED: {
			return produce(state, (draftState) => {
				draftState.masterStatusList.loading = LoadState.Failed;
				draftState.masterStatusList.error = "Failed to fetch master external status list";
			});
		}

		// Single Master Status Actions
		case FETCH_MASTER_EXTERNAL_STATUS_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.masterStatus.loading = LoadState.InProgress;
				draftState.masterStatus.data = defaultExternalLeadMasterStatus;
			});
		}

		case FETCH_MASTER_EXTERNAL_STATUS_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.masterStatus.loading = LoadState.Loaded;
				draftState.masterStatus.data = data;
				draftState.masterStatus.error = null;
			});
		}

		case FETCH_MASTER_EXTERNAL_STATUS_FAILED: {
			return produce(state, (draftState) => {
				draftState.masterStatus.loading = LoadState.Failed;
			});
		}

		case CLEAR_EXTERNAL_STATUS_STATE: {
			return defaultExternalLeadStatusState;
		}
		case CLEAR_MASTER_EXTERNAL_STATUS_STATE: {
			return defaultExternalLeadStatusState;
		}

		// Outlet External Status Lifecycle
		case FETCH_OUTLET_EXTERNAL_STATUS_LIFECYCLE_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.outlet_external_status_lifecycle.loading = LoadState.InProgress;
				draftState.outlet_external_status_lifecycle.list = [];
				draftState.outlet_external_status_lifecycle.totalRecords = 0;
				draftState.outlet_external_status_lifecycle.error = null;
			});
		}

		case FETCH_OUTLET_EXTERNAL_STATUS_LIFECYCLE_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.outlet_external_status_lifecycle.loading = LoadState.Loaded;
				draftState.outlet_external_status_lifecycle.list = data;
				draftState.outlet_external_status_lifecycle.totalRecords = data.length;
				draftState.outlet_external_status_lifecycle.error = null;
			});
		}

		case FETCH_OUTLET_EXTERNAL_STATUS_LIFECYCLE_FAILED: {
			const { errorMessage } = action.payload;
			return produce(state, (draftState) => {
				draftState.outlet_external_status_lifecycle.loading = LoadState.Failed;
				draftState.outlet_external_status_lifecycle.error = errorMessage;
			});
		}

		default: {
			return state;
		}
	}
};
